import React from "react"
import {useNavigate, Link} from "react-router-dom";
import TimeOutModal from "../Assets/TimeOutModal";
import {useState, useEffect} from "react"
import {useTranslation, Trans} from "react-i18next";
import {Row, Alert, Col, Form, Input, Label, FormGroup, FormFeedback} from "reactstrap";
import useInput from "../Assets/UseInput";
import BreadCrumb from "../Layout/BreadCrumb";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

var serialize = require('serialize-javascript');
var moment = require('moment')


function Information(props){
    // fetch data from local Storage
    let history = useNavigate();
    const [d, setDead] = useState()
    const [isLoading, setIsLoading] = useState(true);
    // set control value and name to classic inputs using the custom Hook useInput
    const {value: Field1ReferenceFile, bind: bindField1ReferenceFile, reset: resetField1ReferenceFile } = useInput('');
    const {value: Field0CourtierName, bind: bindField0CourtierName, reset: resetField0CourtierName } = useInput('');
    const {value: Field0InsurerName, bind: bindField0InsurerName, reset: resetField0InsurerName } = useInput('');

    // radio input custom handleChange
    const [radio, setRadio] = useState("");
    const handleChangeRadio = (e) => {
        let value = e.target.value
        setRadio(value);
    }

    const [stored, setStored] =  useState("")

    useEffect(() => {
                    window.scrollTo(0, 0)
        const dead = localStorage.getItem('isDead')
      //console.log(dead)



        const fetchData = () => {
            setIsLoading(true);
            const dead = localStorage.getItem('isDead')
            //console.log(dead)
            dead === "true" ? setDead(true) : setDead(false)
            const information = JSON.parse(localStorage.getItem('information'))
            //console.log('information :' + information);

            if (information) {
                setStored(true)
                !!information.Field0CourtierInsurerChoice && setRadio(information.Field0CourtierInsurerChoice)
                !!information.Field0CourtierName && resetField0CourtierName(information.Field0CourtierName)
                !!information.Field0InsurerName && resetField0InsurerName(information.Field0InsurerName)
                !!information.Field1ReferenceFile && resetField1ReferenceFile(information.Field1ReferenceFile)
            }
            setIsLoading(false);
        };
        fetchData()
    }, []);

    const nextLocation = {
        pathname: '../personal-details',
        state: { d: d }
    }
    const handleNext = (e) =>{
        e.preventDefault()
        history(nextLocation)
    }

    // Submit and validation
    const [NotValid, setNotValid] = useState(false)
    const handleSubmit = (evt) => {

                    window.scrollTo(0, 0)
        evt.preventDefault();
        let notValid = radio === "" || Field1ReferenceFile === "" || (Field0CourtierName === "" && Field0InsurerName === "")
        //console.log(notValid)
        setNotValid(notValid)
        if (!notValid){
            let information
            if (radio === "insurer") {
                information = {Field0CourtierInsurerChoice: radio, Field0InsurerName : Field0InsurerName, Field1ReferenceFile : Field1ReferenceFile}}
            else {
                information = {Field0CourtierInsurerChoice: radio, Field0CourtierName: Field0CourtierName, Field1ReferenceFile : Field1ReferenceFile}
            }
            //let stringInfo = JSON.stringify(information)
            let stringInfo= serialize(information, {isJSON: true});
            localStorage.setItem("information" , stringInfo)
            let t = localStorage.getItem('t')
            //console.log(t)
            if (!t){
                let date = new Date(Date.now() + 2 * (60 * 60 * 1000) );
                localStorage.setItem('t', date);
            }

            //console.log(JSON.parse(stringInfo))
            history(nextLocation)
        }

    }

    const { i18n } = useTranslation();

    return (
        <div className={d? "death" : "injured"}>
            { !!isLoading ? (
                    <div className={'text-center pt-5'}><img className={'d-inline-block'} src="/accidentinfo/spinner.svg" alt=""/></div>
                ) :
                <div>
                    <div className="container">
                        <TimeOutModal i18n={i18n} />
                        <BreadCrumb n={1}/>
                        <Row>
                            <Col>
                                <h3>{  i18n.t('RENSEIGNEMENTGENERAUX') }</h3>
                                <Trans i18nKey={'DONTFORGETDOCS'}>
                                    <p>N’oubliez surtout pas de garder les documents nécessaires sous la main. Vous trouverez de plus amples informations au sujet de ces documents sur <a href='/accidentinfo' target='_blank'>//www.questionnaireapresaccident.be</a>.</p>
                                </Trans>
                                { NotValid &&
                                <Alert color="danger"><FontAwesomeIcon className="pre" icon={['fas', 'hand-point-right']} /> <strong>{  i18n.t('Erreur(s) dans votre formulaire') }</strong>
                                <hr className="message-inner-separator"/>
                                    <p>{i18n.t('Merci de vérifier les champs indiqués en rouge')}</p></Alert>
                                }
                                <Form>
                                    <div className="formlevel01">
                                        <FormGroup check>
                                            <Label for="field0InsurerName" className={(NotValid && radio === "") ? "text-danger" : "text"}>{ !!d ?  i18n.t('NOMASSUREURDEATH') : i18n.t('NOMASSUREUR')  } <span className={"text-danger"}>*</span></Label>
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field0ChoiceInsurerCourtier" onChange={handleChangeRadio} value="insurer"  checked={radio === "insurer"} />
                                                    {  i18n.t('field0ChoiceInsurer') }
                                                </Label>
                                            </div>
                                            { (radio === "insurer") &&
                                            <div className="formlevel02">
                                                <FormGroup>
                                                    <Label for="field0InsurerName">{  !!d ? i18n.t('L’assureur du défunt') : i18n.t('Votre assureur') } <span className={"text-danger"}>*</span></Label>
                                                    <Input type="text" maxLength={500} className="form-control"  {...bindField0InsurerName} placeholder={ d?  i18n.t('PLACEHOLDERNOMASSUREURDEATH'): i18n.t('PLACEHOLDERNOMASSUREUR')  } invalid={(NotValid && Field0InsurerName === "")? true : undefined}/>
                                                    <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </FormGroup>
                                            </div>
                                            }
                                            <div className="checkbox">
                                                <Label>
                                                    <Input type="radio" name="Field0ChoiceInsurerCourtier" value="courtier"  onChange={handleChangeRadio} checked={radio === "courtier"} />
                                                    {  i18n.t('field0ChoiceCourtier') }
                                                </Label>
                                            </div>
                                            {(radio === "courtier") &&
                                            <div className="formlevel02" >
                                                <FormGroup>
                                                    <Label for="field0CourtierName">{ !!d ? i18n.t('Intermédiaire d\'assurance du défunt') : i18n.t("Votre intermédiaire d'assurance")} <span className={"text-danger"}>*</span></Label>
                                                    <Input type="text" maxLength={500} className="form-control" {...bindField0CourtierName} placeholder={!!d ? i18n.t('PLACEHOLDERNOMCOURTIERDEATH') : i18n.t('PLACEHOLDERNOMCOURTIER')} invalid={(NotValid && Field0CourtierName==="")? true : undefined}/>
                                                    <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                                </FormGroup>
                                            </div>
                                            }
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="field1ReferenceFile">{ i18n.t('REFERENCEFILE') } <span className={"text-danger"}>*</span></Label>
                                            <Input type="text" maxLength={500} className="form-control" {...bindField1ReferenceFile} placeholder={i18n.t('PLACEHOLDERREFERENCEFILE') } invalid={(NotValid && Field1ReferenceFile === "")? true : undefined}/>
                                            <FormFeedback>{  i18n.t('Obligatoire') }</FormFeedback>
                                        </FormGroup>

                                        { !stored &&
                                    <div className="button-wrapper">
                                        <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Enregistrer') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                    </div>
                                    }
                                    { stored &&
                                        <div className="button-wrapper">
                                            <button type="submit"  onClick={handleSubmit} className="btn btn-primary small">{  i18n.t('Mettre à jour') }<FontAwesomeIcon icon={['fas', 'arrow-right']} /></button>
                                        </div>
                                        }
                                    </div>


                                </Form>
                                <span className={"text-danger"}>*</span> {  i18n.t('Renseignement indispensable') }<br />
                            </Col>
                        </Row>
                    </div>
                </div>}
        </div>

    )
}

export default Information
